module.exports = "<div class=\"toolbar-user\" *ngIf=\"user\">\n  <cm-avatar class=\"toolbar-user__avatar\" [image]=\"user.getPrimaryPicture()\" (click)=\"goToProfile()\"></cm-avatar>\n  <p class=\"toolbar-user__firstname\">{{ user.firstname }}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-user/toolbar-user.component.html
// module id = ../../../../../src/app/toolbar/toolbar-user/toolbar-user.component.html
// module chunks = 4